//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
let d=[[[0,"BsmMemory",0,0],[0,"CpuTimeOption",1,0],[0,"CpuTimeValidationTolerance",1,0],[0,"DeltaBsmMemory",0,0],[0,"DeltaCpuTime",0,0],[0,"DeltaNxProcessMemory",0,0],[0,"DeltaRealTime",0,0],[0,"DeltaWorkingSetMemory",0,0],[0,"MaxBsmMemory",0,0],[0,"MinAbsMemoryValidationTolerance",1,0],[0,"MinAbsTimeValidationTolerance",1,0],[0,"NxProcessMemory",0,0],[0,"ProcessMemoryOption",1,0],[0,"ProcessMemoryValidationTolerance",1,0],[0,"PromptForUserCommentOption",1,0],[0,"RealTimeOption",1,0],[0,"RealTimeValidationTolerance",1,0],[0,"UserComment",1,0],[0,"WorkingSetMemory",0,0],[0,"WorkingSetMemoryOption",1,0],[0,"WorkingSetMemoryValidationTolerance",1,0]],[[[],"Dispose",{},0,0],[[],"StartPerformanceMonitor",{},0,0],[["userComment"],"StartPerformanceMonitorWithLabel",{},1,0],[[],"RecordPerformanceResults",{},0,0],[[],"StopPerformanceMonitor",{},0,0]],[]];
SPLM.PerformanceManager = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PerformanceManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PerformanceManagerOutputDevice = Object.freeze({
    "Syslog" : "Syslog", "ListingWindow" : "ListingWindow", "Xml" : "Xml", "None" : "None"});

export default SPLM;